import { JsonField } from "react-admin-json-view";
import {
  List,
  Datagrid,
  TextField,
  ExportButton,
  CreateButton,
  TextInput,
  TopToolbar,
  FilterButton,
} from "react-admin";
import ActionsDropdown from "../../components/ActionsDropdown";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";

const postFilters = [<TextInput label="Nome" source="name" alwaysOn />];
const ListActions = () => (
  <TopToolbar>
    {/* <SelectColumnsButton /> */}
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const SystemSettingList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Configuração de sistema"
        firstPath="/#/system-settings/crud"
        actionType="create"
      />
      <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
        <CardContent>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <List>
                <Datagrid>
                  <TextField source="id" />
                  <TextField source="name" label="Nome" />
                  <JsonField source="value" label="Valor" />
                  <ActionsDropdown />
                </Datagrid>
              </List>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
